import { render, staticRenderFns } from "./sales-order-edi.vue?vue&type=template&id=270f2956"
import script from "./sales-order-edi.vue?vue&type=script&lang=js"
export * from "./sales-order-edi.vue?vue&type=script&lang=js"
import style0 from "./sales-order-edi.vue?vue&type=style&index=0&id=270f2956&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports